import { EJavaClassNames } from '@adaptiva/data-service';
import { OneSiteIntuneConstants } from '@adaptiva/onesite/onesite-intune';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCloudContentSettingsEditor } from '../../../cloud-settings/cloud-content-settings/base-cloud-content-settings';

@Component({
	standalone: false,
	selector: 'app-onesite-intune-cloud-content-settings',
	templateUrl: '../../../cloud-settings/cloud-content-settings/cloud-content-settings-editor.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OneSiteIntuneCloudContentSettingsEditorComponent extends BaseCloudContentSettingsEditor {

	constructor() {
		super(
			EJavaClassNames.CloudContentSettings,
			OneSiteIntuneConstants.INTUNE_CLOUD_CONTENT_SETTINGS
		);
	}

}
